import { creating, exist, Id } from '@campaign-portal/namespace/common/id';
import {
	MailTemplateType,
	UserNotificationCategory,
	UserNotificationType,
} from '@campaign-portal/namespace/common/enums';
import { MailTemplate } from '@campaign-portal/namespace/entities/mail-template/specs';

export interface MailTemplateEntityConfig<ID = creating | exist> extends Partial<MailTemplate<ID>> {
	id: ID;
}

export class MailTemplateEntity<ID = creating | exist> implements MailTemplate<ID> {
	id: ID;
	type: MailTemplateType;
	body: string;
	ccId?: Id<exist>;
	notificationType: UserNotificationType;
	notificationCategory: UserNotificationCategory;
	subject: string;
	imageUrl?: string;
	createdBy?: string;
	creationDate?: string | null;
	lastUpdated?: string | null;
	modifiedBy?: string | null;

	constructor(config: MailTemplateEntityConfig<ID>) {
		this.id = config.id;
		this.type = config.type ?? MailTemplateType.CUSTOM;
		this.body = config.body ?? '';
		this.ccId = config.ccId;
		this.notificationType = config.notificationType as UserNotificationType;
		this.notificationCategory = config.notificationCategory as UserNotificationCategory;
		this.subject = config.subject ?? '';
		this.imageUrl = config.imageUrl;
		this.createdBy = config.createdBy ?? undefined;
		this.creationDate = config.creationDate ?? undefined;
		this.lastUpdated = config.lastUpdated ?? undefined;
		this.modifiedBy = config.modifiedBy ?? undefined;
	}

	isDefault(): boolean {
		return this.type === MailTemplateType.DEFAULT;
	}

	isCustom(): boolean {
		return this.type === MailTemplateType.CUSTOM;
	}

	is2FA(): boolean {
		return (
			this.notificationCategory === UserNotificationCategory.TWO_FA_ACTIVATION ||
			this.notificationCategory === UserNotificationCategory.TWO_FA_SECRET_KEY_RESET ||
			this.notificationCategory === UserNotificationCategory.TWO_FA_DEACTIVATION_NOTIFICATION
		);
	}

	canClone(): boolean {
		return this.isDefault() && !this.is2FA();
	}

	clone(): MailTemplateEntity<null> {
		return new MailTemplateEntity({
			...this,
			id: null,
			type: MailTemplateType.CUSTOM,
			notificationCategory: undefined as unknown as UserNotificationCategory,
		});
	}
}
